/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.tool.access.rpc.ToolAccessService
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type ToolAccessRpcError = {
  reason: ToolAccessFailureReason;
  scope?: string;
  approverUserId?: number;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type ToolAccessFailureReason =
  | 'APPROVER_NOT_AN_ADMIN'
  | 'REQUESTER_ALREADY_HAS_SCOPE'
  | 'REQUESTER_HAS_ACTIVE_REQUEST'
  | 'SCOPE_NOT_SUPPORTED'
  | 'MESSAGE_TOO_LONG'
  | unhandledEnumCase;

export type ActiveRequestStatus = 'ACTIVE' | 'NON_ACTIVE' | unhandledEnumCase;

export type ActiveToolAccessRequest = {
  id: number;
  portalId: number;
  createdAt: number;
  expiresAt: number;
  approver: Approver;
};

export type Approver = {
  userId: number;
  email: string;
  firstName: string;
  lastName: string;
};

export type RequestStatus = 'PENDING' | 'APPROVED' | unhandledEnumCase;

export type GetActiveToolAccessRequestForScopeRequest = {
  scopeName: string;
  locale?: string;
};

export type GetActiveToolAccessRequestForScopeResponse = {
  toolName: string;
  status: ActiveRequestStatus;
  activeToolAccessRequest?: ActiveToolAccessRequest;
};

export type RequestToolAccessRequest = {
  scope: string;
  approverUserId: number;
  message?: string;
};

export type RequestToolAccessResponse = {
  id: number;
  scope: string;
  approverUserId: number;
  requesterUserId: number;
  portalId: number;
  message?: string;
  requestStatus: RequestStatus;
  createdAt: number;
  expiresAt: number;
  roleName: string;
};

export type RequestToolAccessRequestType = Requestify<RequestToolAccessRequest>;
export type RequestToolAccessResponseType = RequestToolAccessResponse;
export type RequestToolAccessErrorType = ToolAccessRpcError & HubspotMetadata;
export const requestToolAccessRpc: ChirpAvroRpcDetails<
  RequestToolAccessRequestType,
  RequestToolAccessResponseType,
  RequestToolAccessErrorType,
  false
> = {
  serviceName: 'com.hubspot.tool.access.rpc.ToolAccessService',
  rpcName: 'requestToolAccess',
  auth: 'app',
  fingerprint: '52hQgmgzK0a18G83i5nXCOP5UDq0a_Cf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetActiveToolAccessRequestForScopeRequestType =
  Requestify<GetActiveToolAccessRequestForScopeRequest>;
export type GetActiveToolAccessRequestForScopeResponseType =
  GetActiveToolAccessRequestForScopeResponse;
export type GetActiveToolAccessRequestForScopeErrorType = ToolAccessRpcError &
  HubspotMetadata;
export const getActiveToolAccessRequestForScopeRpc: ChirpAvroRpcDetails<
  GetActiveToolAccessRequestForScopeRequestType,
  GetActiveToolAccessRequestForScopeResponseType,
  GetActiveToolAccessRequestForScopeErrorType,
  false
> = {
  serviceName: 'com.hubspot.tool.access.rpc.ToolAccessService',
  rpcName: 'getActiveToolAccessRequestForScope',
  auth: 'app',
  fingerprint: 'BOE_xKbmHOOCHJV7ySKW5OP5UDq0a_Cf',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
